const loadAnalytics = () => {

	let newScript = document.createElement("script");
	newScript.type = "text/javascript";
	newScript.setAttribute("async", "true");
	newScript.setAttribute("src", "https://www.googletagmanager.com/gtag/js?id=UA-419793-38");
	document.body.appendChild(newScript);

	window.dataLayer = window.dataLayer || [];

	function gtag() {
		dataLayer.push(arguments);
	}

	gtag('js', new Date());

	gtag('config', 'UA-419793-38');

}

window.addEventListener('CookieInformationConsentGiven', function (event) {
	if (window.CookieInformation.getConsentGivenFor('cookie_cat_marketing')) {
		loadAnalytics();
	}
}, false);
